import { GetProgramTopoStation } from './get-program-topo-station.model';

export class GetProgramTopoHole {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            // Lynx Cloud API sometimes uses PascalCase and sometimes camelCase
            // Lynx Drive API uses camelCase.
            this.id = json.Id ?? json.id;
            this.name = json.Name ?? json.name;
            this.stations = json?.Stations?.map(station => new GetProgramTopoStation(station)) ?? json?.stations?.map(station => new GetProgramTopoStation(station));

            delete this['Name'];
            delete this['Id'];
            delete this['Stations'];
        }
    }

    id: number;
    name: string;
    stations: GetProgramTopoStation[];
}
